import { render, staticRenderFns } from "./mm-no-result.vue?vue&type=template&id=35ca7fc4&"
import script from "./mm-no-result.vue?vue&type=script&lang=js&"
export * from "./mm-no-result.vue?vue&type=script&lang=js&"
import style0 from "./mm-no-result.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports